export default __webpack_public_path__ + "static/media/lcs-online-icon.668fcb8a.svg";